export class NoTargetInfraError extends Error {
	constructor(message: string) {
		super(message);
	}
}
